module.exports = __webpack_public_path__ + "img/youtube.5584d2e1.svg";